import { Box, Tag } from '@nimbus-ds/components';
import { CheckoutPaymentOptionDto } from '@tiendanube/common';
import {
  InteractiveListPriv,
  InterfaceNameChecked,
  Text,
} from '@tiendanube/components';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import { buildPaymentOptionDescription, getPaymentOptionIcon } from './utils';

interface PaymentOptionRowProps {
  paymentProviderName: string;
  option: CheckoutPaymentOptionDto;
  isSelected: boolean;
  onChange: (e: InterfaceNameChecked) => void;
}

export function PaymentOptionRow({
  paymentProviderName,
  option,
  isSelected,
  onChange,
}: Readonly<PaymentOptionRowProps>): JSX.Element {
  const t = useTranslationMarketing(
    'promotions.settingsPage.limits.paymentOptions',
  );
  const isDisabled = option.legacyDiscount > 0;
  const IconComponent = getPaymentOptionIcon(option.translationKey);
  const description = buildPaymentOptionDescription(
    option.translationKey,
    option.name,
    paymentProviderName,
    t,
    false,
  );

  return (
    <InteractiveListPriv.CheckItem
      key={option.id}
      name={option.id}
      checked={isSelected}
      disabled={isDisabled}
      onChange={onChange}
      title=""
      blockLeft={
        <Box
          display="grid"
          width="100%"
          gridTemplateColumns={{ xs: '65fr 35fr', md: '70fr 30fr' }}
          alignItems="center"
        >
          <Box display="flex" alignItems="center" gap="2">
            <IconComponent size="small" />
            <Text>{description}</Text>
          </Box>

          {isDisabled && (
            <Tag appearance="neutral">
              {t('modal.discountLabel', { percentage: option.legacyDiscount })}
            </Tag>
          )}
        </Box>
      }
    />
  );
}
